
import styles from './ClassListItem.module.css';

interface Props {
    time: string;
    program: string;
    classLabel: string;
    level: string;
    communityCode: string;
}

function ClassListItem({
    time,
    program,
    classLabel,
    level,
    communityCode
}: Props) {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.leftSection}>
        <div className={styles.dayTime}>
            {time}
        </div>
        <div className={styles.detials}>
          <span>{program}</span>
          <span>{classLabel}</span>
          <span>{level}</span>
        </div>
      </div>
      <div className={styles.communitySection}>
        <span className={styles.communityCode}>{communityCode}</span>
      </div>
    </div>
  );
};

export { ClassListItem }
